import { UntypedFormGroup } from '@angular/forms';

export const submitHelper = (form: UntypedFormGroup) => {
  Object.keys(form.controls).forEach((key: string) => {
    form.controls[key].markAsTouched();
    form.controls[key].updateValueAndValidity();
  });
};
